export type TotalsLine = { kWh?: number; tariffPerKWh?: number }

export function calcCreditNoteTotals(lines: TotalsLine[], vatPercentage: number) {
  const subTotalCents = lines.reduce(
    (s, l) => s + Math.round((l.kWh || 0) * (l.tariffPerKWh || 0) * 100),
    0
  )
  const vatCents = Math.round(subTotalCents * (vatPercentage / 100))
  return {
    subTotalCents,
    vatCents,
    totalCents: subTotalCents + vatCents
  }
}
